import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, finalize, Observable, of, shareReplay, tap } from 'rxjs';
import * as settings from 'src/app/shared/lib/api-constant';
import { DndPortalPoint } from 'src/app/shared/lib/api-constant';

@Injectable({
  providedIn: 'root'
})
/**
 * Service responsible for handling home-related API operations.
 * 
 * @class HomeService
 * @description Manages API requests for the home module, particularly KPI data retrieval.
 */
export class HomeService {
  [x: string]: any;
  private origionRegionPromise = new BehaviorSubject<any>({});
  public $origionRegion = this.origionRegionPromise.asObservable();

  private destinationRegionPromise = new BehaviorSubject<any>({});
  public $destinationRegion = this.destinationRegionPromise.asObservable();

  constructor(protected http: HttpClient) { }

  getPortsOnMap(request: any = {}) {
    const url = settings.DndPortalPoint.DndHomePagePoint.GET_PORT_ON_MAP;
    return this.http.post(url, request);
  }
 getPortsOnMapData(request: any = {}, portType: string) {
    const url = settings.DndPortalPoint.DndHomePagePoint.GET_PORT_ON_MAP_DATA+ '?portType=' + portType;
    return this.http.post(url, request);
  }


  /**
   * @method getKpiListData
   * @description Fetches the KPI data for the home page.
   * @param {any} request - The request object to send to the API.
   * @returns {Observable<any>} The observable response from the API.
   */
  getKpiListData(request: any = {}): Observable<any> {
    const url = settings.DndPortalPoint.DndHomePagePoint.GET_KPI_DATA;
    return this.http.post(url, request);
  }

  //  getKpiSettingsData(): Observable<any> {
  //   const url = settings.DndPortalPoint.DndHomePagePoint.GET_KPI_SETTINGS_DATA;
  //   return this.http.get(url);
  // }

  /**
   * @method getPortCarrierChartData
   * @description Fetches the port chart data for the home page.
   * @param {any} request - The request object to send to the API.
   * @returns {Observable<any>} The observable response from the API.
   */
  getPortCarrierChartData(request: any = {}): Observable<any> {
    const url = settings.DndPortalPoint.DndHomePagePoint.GET_PORT_CARRIER_CHART_DATA;
    return this.http.post(url, request);
  }

getPortCarrierChartDataPort(request: any = {}, portType: string): Observable<any> {
  const url = settings.DndPortalPoint.DndHomePagePoint.GET_PORT_CARRIER_CHART_DATA_PORT + '?portType=' + portType;
  return this.http.post(url, request);
}

  /**
   * @method getWeeklyChartData
   * @description Fetches the weekly chart data for the home page.
   * @param {any} request - The request object to send to the API.
   * @returns {Observable<any>} The observable response from the API.
   */
  getWeeklyChartData(request: any = {}): Observable<any> {
    const url = settings.DndPortalPoint.DndHomePagePoint.GET_WEEK_CHART_DATA;
    return this.http.post(url, request);
  }
 getWeeklyChartDataPort(request: any = {}, portType: string): Observable<any> {
  const url = settings.DndPortalPoint.DndHomePagePoint.GET_WEEK_CHART_DATA_PORT + '?portType=' + portType;
  return this.http.post(url, request);
}
  

  /**
   * @method getOriginRegion
   * @description Fetches the origin region data.
   * @returns {Observable<any>} The observable response from the API.
   */
  getOriginRegion(): Observable<any> {
    return this.http.get(DndPortalPoint.DndCommonEndppoint.ORIGIN_REGION);
  }

  /**
   * @method getOrigionRegion
   * @description Updates the origin region data.
   * @param {any} region - The region data to update.
   */
  getOrigionRegion(region: any): void {
    this.origionRegionPromise.next(region);
  }

  /**
   * @method getDestinationRegion
   * @description Updates the destination region data.
   * @param {any} region - The region data to update.
   */
  getDestinationRegion(region: any): void {
    this.destinationRegionPromise.next(region);
  }

  getMasterKpiListData(): Observable<any> {
    const url = settings.DndPortalPoint.DndHomePagePoint.GET_MASTER_KPI_DATA;
    return this.http.get(url);
  }

  updateUserKpiMapping(request: any): Observable<any> {
    const url = settings.DndPortalPoint.DndHomePagePoint.UPDATE_USER_KPI_MAPPING;
    return this.http.post(url, request);
  }
getKpiData(kpiId: number, payload: any): Observable<any> {
    const url = `${settings.DndPortalPoint.DndHomePagePoint.GET_KPI}/${kpiId}`;
    return this.http.post(url, payload);
}

  public kpiSettingsCache: any  = null;

  private kpiSettingsReq$?: Observable<any>;

  // getKpiSettingsDataCached(): Observable<any> {
  //   if (this.kpiSettingsCache) {
  //     return of(this.kpiSettingsCache);
  //   }
  //   if (this.kpiSettingsReq$) {
  //     return this.kpiSettingsReq$;
  //   }
  //   const url = settings.DndPortalPoint.DndHomePagePoint.GET_KPI_SETTINGS_DATA;
  //   this.kpiSettingsReq$ = this.http.get(url).pipe(
  //     tap((res) => (this.kpiSettingsCache = res)),
  //     finalize(() => (this.kpiSettingsReq$ = undefined)),
  //     shareReplay(1)
  //   );
  //   return this.kpiSettingsReq$;
  // }



  invalidateKpiSettings(): void {
    this.kpiSettingsCache = null;
  }
  getKpiSettingsData(): Observable<any> {
    const url = settings.DndPortalPoint.DndHomePagePoint.GET_KPI_SETTINGS_DATA;
    return this.http.get(url);
  }

}